import React, { FC } from "react";
import { BsPinAngle } from "react-icons/bs";
import { MdOutlineEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import { TrashSvg } from "../../../../../../components/svg/TrashSvg";
import { ContactNoteModel } from "../../../../../../factories/contacts/models/contact-note.models";
import { usePinContactNoteMutation } from "../../../../../../slices/ContactNotesSlice";
import { usePinWorkNoteMutation } from "../../../../../../slices/WorkNotesSlice";
import {
  mapNoteToViewModel,
  NoteCard,
  useCanEditNote,
} from "../../../../components/notes";

type Props = {
  note: ContactNoteModel;
  setCurrentNote: (value: ContactNoteModel) => void;
  setIsOpenAdd: (isOpenAdd: boolean) => void;
  deleteContactNote: (value: ContactNoteModel) => void;
  setIsWork: React.Dispatch<React.SetStateAction<boolean>>;
  onViewNote: (note: ContactNoteModel) => void;
};

export const ContactNote: FC<Props> = ({
  note,
  setCurrentNote,
  setIsOpenAdd,
  deleteContactNote,
  setIsWork,
  onViewNote,
}) => {
  const navigate = useNavigate();
  const canEdit = useCanEditNote();
  const [pinNote, { isLoading: isLoadingPin }] = usePinContactNoteMutation();
  // Work notes in this list are pinned through the work item (QA batch 14).
  const [pinWorkNote, { isLoading: isLoadingWorkPin }] =
    usePinWorkNoteMutation();

  return (
    <NoteCard
      note={mapNoteToViewModel(note)}
      onView={() => onViewNote(note)}
      onOpenWork={(workId) => navigate("/work/" + workId)}
      actions={[
        ...(canEdit(note)
          ? [
              {
                name: "Edit",
                action: () => {
                  setCurrentNote({ ...note, noteId: note.noteId });
                  setIsWork(!!note.workName);
                  setIsOpenAdd(true);
                },
                icon: <MdOutlineEdit size={20} />,
              },
            ]
          : []),
        {
          name: note.isPinned ? "Unpin" : "Pin",
          action: () => {
            if (!isLoadingPin && !isLoadingWorkPin) {
              const pin = note?.workId ? pinWorkNote : pinNote;
              pin({
                id: note?.noteId || note?.id || "",
                isPinned: !note?.isPinned,
              });
            }
          },
          icon: <BsPinAngle size={20} />,
        },
        {
          name: "Delete",
          action: () => deleteContactNote(note),
          icon: <TrashSvg />,
          extraClasses: "text-[#DC2626]",
          iconColor: "text-[#DC2626]",
        },
      ]}
    />
  );
};
